/*
 * UI Configuration collection and model
 */

define([
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
], function (Backbone, $, _, Messenger, Properties) {
  var UIConfigModel = {};

  UIConfigModel.password = Backbone.Model.extend({
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/uiconfigs/password";
    },
  });

  UIConfigModel.uiConfig = Backbone.Model.extend({
    idAttribute: "configurationId",
    defaultValidateAttributes: ["name", "contextIds"],
    defaults: function () {
      //using a function instead of the typical hash because the arrays persist between new objects
      //use the user defaults for language, touchpoint, and context
      var defaultLanguage = Messenger.reqres.request("default:response:language");
      var defaultTouchPoint = Messenger.reqres.request("default:touchpoint");
      var defaultContext = Messenger.reqres.request("default:topic:context");
      var defaults = {
        name: "",
        password: "",
        qaMode: false,
        languageId: defaultLanguage,
        touchPointId: defaultTouchPoint,
        defaultTouchPointId: defaultTouchPoint,
        contextIds: [defaultContext],
        privilegedAreaRoleIds: [],
      };
      return defaults;
    },
    generatePassword: function () {
      //make a POST call to the server to generate a password string
      var passwordModel = new UIConfigModel.password();
      passwordModel.fetch({ type: "POST" }); //use POST because the call is not idempotent
      passwordModel.onSynced(function () {
        this.set("password", passwordModel.get("value"));
      }, this);
    },
    _validateDuplicateUiConfigName: function (value) {
      if (this.collection) {
        var duplicateName = false;
        this.collection.each(function (config) {
          //check if the other object has the same name (ignore case) and is actually a different object
          if (config.get("name").toLowerCase() === value.toLowerCase() && config.cid !== this.cid) {
            duplicateName = true;
          }
        }, this);
        if (duplicateName) return $.t("admin.uiConfig.uniqueMessage");
      }
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "name") {
        return (
          this.validateRequiredValue(value, { maxLength: 50 }) ||
          this.validateSafeCharacters(value) ||
          this._validateDuplicateUiConfigName(value)
        );
      } else if (attribute == "contextIds") {
        if (!value || !value.length) {
          return $.t("admin.uiConfig.noContext");
        }
      }
    },
  });

  UIConfigModel.uiConfigs = Backbone.Collection.extend({
    model: UIConfigModel.uiConfig,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    addNewUIConfig: function () {
      var newModel = new UIConfigModel.uiConfig();
      this.add(newModel);
      return newModel;
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/uiconfigs";
    },
  });

  //Reqres handler to get all the UI configs for the active KB
  Messenger.reqres.setHandler(
    "ui:configs",
    function () {
      var configs = new UIConfigModel.uiConfigs();
      configs.fetch();
      return configs;
    },
    this,
  );

  return UIConfigModel;
});
